module.exports = "../../app/cells/components/blog/card_cell.rb";